var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"parent",class:[!_vm.showDetails ? 'parent-2' : ''],style:(_vm.style)},[_c('v-card',{on:{"click":_vm.showRegister}},[_c('v-card-title',{staticClass:"info-title"},[_c('div',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.tarh.Title)+" ")])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }